import { dateDiff } from '@/utils/formatDate';
import {
  AuthorName,
  PublishingTime,
  Wrapper,
  Dot,
  TldrTag,
  TimeWrapper,
} from './styles';

type AuthorAndDateTimeProps = {
  dateTime: string;
  author: Author;
  className?: string;
};

type Author = {
  firstName: string;
  lastName: string;
  imgSrc?: string;
};

export function AuthorAndDateTime({
  dateTime = null,
  author,
  className,
}: AuthorAndDateTimeProps): JSX.Element {
  return (
    <Wrapper className={className}>
      {author?.firstName && (
        <>
          <AuthorName>
            {author.firstName} {author.lastName}{' '}
          </AuthorName>
          <Dot> ・ </Dot>
        </>
      )}
      <TimeWrapper>
        {dateTime && (
          <PublishingTime dateTime={dateTime}>
            {dateDiff(dateTime)}
          </PublishingTime>
        )}
      </TimeWrapper>
    </Wrapper>
  );
}

AuthorAndDateTime.defaultProps = {
  className: '',
};
